import { motion } from "framer-motion";
import {
  Smartphone,
  Globe,
  Cpu,
  Layout,
  Cloud,
  BookOpen,
  Navigation,
} from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";
import SectionHeading from "../../components/premium/layout/SectionHeading";
import MagneticButton from "../../components/premium/hero/MagneticButton";

const services = [
  { icon: Globe, title: "Web Development", desc: "Scalable React & modern web applications" },
  { icon: Smartphone, title: "App Development", desc: "Cross-platform mobile solutions" },
  { icon: Cpu, title: "AI Solutions", desc: "Intelligent automation & ML integration" },
  { icon: Layout, title: "UI/UX Design", desc: "Premium interfaces users love" },
  { icon: Cloud, title: "Cloud Services", desc: "AWS, DevOps & infrastructure" },
  { icon: BookOpen, title: "LMS Platforms", desc: "Custom learning management systems" },
  { icon: Navigation, title: "Ride Booking Systems", desc: "Mobility & fleet management apps" },
];

export default function ServicesPage() {
  return (
    <PageShell>
      <PageHero
        badge="Our Services"
        title="End-to-End"
        highlight="Digital Solutions"
        subtitle="From concept to deployment — we deliver premium technology services for startups and enterprises."
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading badge="Capabilities" title="What We Build" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {services.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                whileHover={{ y: -8 }}
                className="premium-glass rounded-2xl p-6 group cursor-default"
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#2563EB] to-[#1d4ed8] flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform shadow-lg shadow-[#2563EB]/25">
                  <s.icon size={26} />
                </div>
                <h3 className="text-lg font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-sm text-white/55">{s.desc}</p>
              </motion.div>
            ))}
          </div>
          <div className="mt-16 text-center">
            <MagneticButton to="/contact" variant="gold">Start Your Project</MagneticButton>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
